import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowDown, faArrowUp, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import Axios from 'axios';
import React, { Suspense, useEffect } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import CoreNegocio from './containers/CoreNegocio/CoreNegocio';
import Finanzas from './containers/Finanzas/Finanzas';
import Funnel from './containers/Funnel/Funnel';
import Nps from './containers/Nps/Nps';
import UnitEconomics from './containers/UnitEconomics/UnitEconomics';
import Ventas from './containers/Ventas/Ventas';
import * as authActions from './context/auth/authActions';
import AlertState from './context/alerts/alertState';
import Dashboard from './hoc/Dashboard/Dashboard';
import Scanit from './containers/Scanit/Scanit';

library.add(faArrowDown, faArrowUp, faInfoCircle);

const Login = React.lazy(() => {
	return import('./containers/Auth/Login');
});

const App = (props) => {
	const { onTryAutoSignup, isAuthenticated } = props;

	useEffect(() => {
		onTryAutoSignup();
	}, [onTryAutoSignup]);

	if (isAuthenticated) {
		Axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URL;
		Axios.defaults.headers.common = {
			Authorization: `Bearer ${sessionStorage.getItem('token')}`,
		};
	}

	let routes = (
		<Switch>
			<Route path="/auth" render={(props) => <Login {...props} />} />
			<Redirect from="/" to="/auth" />
		</Switch>
	);

	if (isAuthenticated) {
		routes = (
			<Dashboard>
				<Switch>
					<Route path="/unitEconomics" exact component={UnitEconomics} />
					<Route path="/nps" exact component={Nps} />
					<Route path="/core" exact component={CoreNegocio} />
					<Route path="/finanzas" exact component={Finanzas} />
					<Route path="/ventas" exact component={Ventas} />
					<Route path="/funnel" exact component={Funnel} />
					<Route path="/scanit" exact component={Scanit} />
					<Redirect from="/" to="/unitEconomics" />
				</Switch>
			</Dashboard>
		);
	}

	return (
		<AlertState>
			<Suspense fallback={<p>Loading...</p>}>{routes}</Suspense>
		</AlertState>
	);
};

const mapStateToProps = (state) => {
	return {
		isAuthenticated: state.auth.token !== null,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		onTryAutoSignup: () => dispatch(authActions.authCheckState()),
	};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
